import {
	getStateRecommendedUniversitiesPostgraduate,
	getStateRecommendedUniversitiesUndergraduate,
	getStateRecommendedClearingUniversities,
} from '@uc/web/shared/data-access';
import { Product, ProductEnum } from '@uc/shared/data-models';

export const getRecommendedUniversitiesSelector = (
	product: Product,
	isClearing = false,
) => {
	if (product === ProductEnum.Postgraduate) {
		return getStateRecommendedUniversitiesPostgraduate;
	} else if (product === ProductEnum.Clearing && isClearing) {
		return getStateRecommendedClearingUniversities;
	}
	return getStateRecommendedUniversitiesUndergraduate;
};
